import logoLogin from "../Assets/Media/logoLogin.png"
import logo from '../Assets/Media/logo.png';
import noData from './../Assets/Media/noData.png'
import deleteIcon from "../Assets/Media/deleteAccount.gif"
import bgAuth from '../Assets/Media/bgAuth.png';
import uploadImage from '../Assets/Media/uploadImage.png';
import dashboardUser from '../Assets/Media/dashboardUser.png';
import profileUser from '../Assets/Media/profile.png';
import engFlag from '../Assets/Media/flag/eng.png';
import indiaFlag from '../Assets/Media/flag/india.png';
import dashboardDark from '../Assets/Media/dashboard_dark.png';
import dashboardLight from '../Assets/Media/dashboard_white.png';
import companyDark from '../Assets/Media/companies_dark.png';
import companyLight from '../Assets/Media/companies_light.png';
import messageDark from '../Assets/Media/message_dark.png';
import messageLight from '../Assets/Media/message_white.png';
import peopleDark from '../Assets/Media/people_dark.png';
import peopleLight from '../Assets/Media/people_white.png';

export const MediaEndpoints = {
    logoLogin,
    logo,
    noData,
    deleteIcon,
    bgAuth,
    uploadImage,
    dashboardUser,
    profileUser,
    flags:{
        engFlag,
        indiaFlag
    },
    dashboardDark,dashboardLight,companyDark,companyLight,messageDark,messageLight,peopleDark,peopleLight
}
export const mediaUrl = ""

export const colorCode = {
    defaultDarkColor:"#749B98",
    defaultLightColor:"#86A9A6",
    boxBgColor: "#E3F1EE",
    graphColorDark:"#548281",
    graphColorLight:"#B8D1D1"
}